import React from 'react'
import {
  formatSpartacusPhoneLabel,
  getSpartacusPhoneHref,
} from 'src/utils/spartacusMappers'
import styled from 'styled-components/macro'

function SpartacusPhoneCell({ phone }) {
  const label = formatSpartacusPhoneLabel(phone)
  const href = getSpartacusPhoneHref(phone)

  if (!href) {
    return <Muted>—</Muted>
  }

  return <PhoneLink href={href}>{label}</PhoneLink>
}

const PhoneLink = styled.a`
  color: ${({ theme }) => theme.colours.bbqBlack};
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.colours.lettuceGreen};
    text-decoration: underline;
  }
`

const Muted = styled.span`
  color: ${({ theme }) => theme.colours.oliveGrey};
`

export default SpartacusPhoneCell
